<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Rewind 15 Sec" class="d-icon d-icon--rewind-15-sec" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.72 1.008a5 5 0 1 1-4.692 5.519.5.5 0 0 1 .994-.105 4 4 0 1 0 1.336-3.424l-.53.476H3a.5.5 0 0 1 0 1H1.527a.28.28 0 0 1-.004 0H1.5a.5.5 0 0 1-.5-.5v-1.5a.5.5 0 0 1 1 0v.4l.695-.625a5 5 0 0 1 3.025-1.24ZM5.977 4.5a.5.5 0 0 1 .5-.5h1.308a.5.5 0 1 1 0 1h-.808v.272c.169-.014.357 0 .548.073.398.15.593.457.68.72.08.242.08.472.08.56v.008c0 .167-.053.421-.177.659-.128.245-.369.54-.78.645-.35.09-.65.037-.893-.096a1.568 1.568 0 0 1-.417-.354l-.013-.014a.5.5 0 0 1 .749-.663c.081.092.12.13.163.154a.133.133 0 0 0 .05.016.306.306 0 0 0 .113-.011c.043-.011.093-.045.142-.14a.647.647 0 0 0 .052-.137.352.352 0 0 0 .011-.062v.003a.816.816 0 0 0-.029-.253.204.204 0 0 0-.035-.068.107.107 0 0 0-.048-.031.33.33 0 0 0-.201.005.653.653 0 0 0-.194.09.5.5 0 0 1-.8-.4V4.5Zm-.785-.461A.5.5 0 0 1 5.5 4.5v3a.5.5 0 1 1-1 0V5.708l-.146.146a.5.5 0 0 1-.707-.707l1-1a.5.5 0 0 1 .545-.108Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconRewind15Sec',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
